<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      COPYRIGHT  © {{ new Date().getFullYear() }}
      <b-link
        class="ml-25"
        href="https://www.facebook.com/jojoyu/"
        target="_blank"
      >SAMS</b-link>
      <span class="d-none d-sm-inline-block">. Security Agency Management System</span>
    </span>

    <span class="float-md-right d-none d-md-block">Jojo Yu, All rights Reserved
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
